export default __webpack_public_path__ + "static/media/bee.9553e669.png";